import { ReactNode } from "react";
import { Link } from "react-router";

import { BreadcrumbItemSeparator } from "./BreadcrumbItemSeparator";

import styles from "./styles.module.css";

/** The `BreadcrumbItem` component properties. */
export interface BreadcrumbItemProps {

  /** The breadcrumb item title. */
  readonly title: string;

  /** The breadcrumb item path. */
  readonly path?: string;

  /** Handles breadcrumb clicks. */
  readonly onClick?: () => void;
}

/** A breadcrumb item. */
export const BreadcrumbItem = (props: BreadcrumbItemProps): ReactNode => {
  const { title, path, onClick } = props;

  if (!path) return <span className={styles.BreadcrumbItem}>{title}</span>;

  return (
    <>
      <Link className={styles.BreadcrumbItem} onClick={onClick} to={path}>
        {title}
      </Link>
      <BreadcrumbItemSeparator />
    </>
  );
};
